import axios from "axios"
import { toast } from "react-toastify";
const instance = axios.create({
    withCredentials: true,
    headers: {
        "Accept": 'application/json',
        "Content-Type": `application/json`
    }
})
// For The activity Log Components
// const instancetwo = axios.create({
//     withCredentials: true,
//     baseURL: "",
//     headers: {
//         "Accept": 'application/json',
//         "Content-Type": `multipart/form-data: boundary=add-random-characters`
//     }
// })
// For The activity Log Components
instance.defaults.withCredentials = true;
const getAxios = async (url, data) => {
    try {
        const res = await instance.get(url, data)
        // console.log("res",res)
        return res
    } catch (err) {
        console.log("Could'nt get the data", err)
    }
}
const postAxios = async (url, data) => {
    console.log('try');
    try {
        const res = await instance.post(url, data)
        return res
    } catch (err) {
        if(err?.response?.data?.status===400){
            toast.warn(err?.response?.data?.errors[0]?.message)
        }
    }
}
const deleteAxios = async (url, data) => {
    const res = await instance.delete(url, data)
    return res
}

const putAxios = async (url, data) => {
    const res = await instance.put(url, data)
    return res
}

export default getAxios;
export { postAxios, deleteAxios, putAxios }